import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { Colors } from 'utils/Visualization';
interface IProps {
  color: string;
  isExpressed?: boolean | null;
  onClick?: () => void;
}

interface IState {}

class View extends Component<IProps, IState> {
  render() {
    const { color, isExpressed, onClick } = this.props;
    const backgroundColor = isExpressed ? color : Colors.Water;

    return (
      <div
        className='test-tube-tile m-1 has-border-1 is-clickable is-unselectable'
        style={{ backgroundColor }}
        onClick={onClick}
      ></div>
    );
  }
}

const TestTubeTile = observer(View);
export default TestTubeTile;
